import { OnInit, Injectable } from '@angular/core';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IPropertyCard } from '../shared/models/propertycard';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { RestService } from '../shared/providers/rest.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { IUser } from '../shared/models/user';
import { LoaderService } from '../shared/providers/loader.service';
import { PropertyFor } from '../shared/enum/enum';
import { ActivatedRoute, Params } from '@angular/router';
export enum FilterSearch {
  SaveSearch = 1,
  Favorites = 2,
  Dislike = 3,
}

@Injectable({
  providedIn: 'root'
})
export class PropertyListingBase extends RestService implements OnInit {

  properties: IPropertyCard[] = [];
  noProperty = 'No properties found.';
  IsLoadingPropertyCard: boolean = false;
  propertyCardView: boolean = true;
  private _propertyCount: number;
  isSearchClicked = false;
  showIs1031Tab = false;
  liveListingHeadingText = 'Live Listing';
  currentFilter = 0;
  IsFromSaveSearch = false;
  public get propertyCount(): number {
    return this._propertyCount;
  }
  public set propertyCount(v: number) {
    this._propertyCount = v;
  }


  searchCriteria = {} as IPropertySearchCriteria;
  user: any;
  enableScrollFn: boolean = true;

  constructor(protected _propertyListingService: PropertyListingService,
    protected http: HttpClient, protected authService: AuthenticationService,
    protected loaderService: LoaderService, protected activatedRoute: ActivatedRoute) {
    super(http);
  }

  ngOnInit() {
    this.loadPageContent();
  }
  isUserLoggedIn = false;
  loadPageContent() {
    this.IsLoadingPropertyCard = true;
    this.loaderService.display(true);
    this.user = this.authService.user;
    this.defaultSearchCriteriaValues();
    this.propertyCount = 0;
    if (this.user != null && this.user != undefined) {
      this.searchCriteria.LoggedInUserId = this.user.Id;
    }
    //if (this.user != '' && this.user != null && this._propertyListingService.fillPrevSearchCriteria) {
    //    this._propertyListingService.fromHome = true;
    //}
    //if (this._propertyListingService.fromHome && this._propertyListingService.criteria != undefined && this._propertyListingService.criteria.TakeCount != undefined) {
    ////if (this._propertyListingService.fromHome) {
    if (this._propertyListingService.criteria != undefined && this._propertyListingService.criteria.TakeCount != undefined) {

      this._propertyListingService.criteria.IsSearchButtonClicked = false;
      this.searchCriteria = this._propertyListingService.criteria;
    }
    ////}             
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    if (loggedUserDetails != null && loggedUserDetails != undefined && loggedUserDetails != '') {
      this.user = loggedUserDetails;
      this.searchCriteria.LoggedInUserId = this.user.Id;
    }
    //if (this.isUserLoggedIn) {
    //  let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    //  this.user = loggedUserDetails;
    //}
    if (this.searchCriteria.PropertyFor === 0 || this.searchCriteria.PropertyFor === null || this.searchCriteria.PropertyFor === undefined) {
      this.searchCriteria.PropertyFor = 601;
    }

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.searchCriteria.IsFavorite = params['isFav'] != undefined ? true : false;
      this.searchCriteria.IsDisliked = params['isDisliked'] != undefined ? true : false;
      this.searchCriteria.Brokerages = params['request'] != undefined ? [] : this.searchCriteria.Brokerages;
    });
    if (this.searchCriteria.IsDisliked) {
      this.searchCriteria.PropertyFor = 602;
    }

    if (this.searchCriteria.IsMapView != true) {
      this.searchCriteria.IsTileList = true;
    }
    this.LoadInitialProperties();
    this.getPropertyTabCount(this.searchCriteria);
  }

  async LoadInitialProperties() {
    await this._propertyListingService.getPropertyListing(this.searchCriteria).subscribe((response: IPropertyCard[]) => {
      this.IsLoadingPropertyCard = false;
      this.properties = response;
      if (this.searchCriteria.PropertyFor == 601) {
        this.propertyTabCount = (response != null && response.length > 0) ? response[0].TotalCount : 0;
      }
      else {
        this.propertyCount = (response != null && response.length > 0) ? response[0].TotalCount : 0;
      }
      this.loaderService.display(false);
      this.currentFilter = 0;
      this.scrollToPropertyCard();
    });
  }

  scrollToPropertyCard() {
    if (this.IsLoadingPropertyCard) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    //  $('html,body').animate({ scrollTop: ($(elementId).offset().top - offset) }, 1000);
  }

  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {

    if (searchParameters.IsMapView == undefined || searchParameters.IsMapView == false) {
      //if (this.propertyCardView != true) {
      //  this.loaderService.display(true);
      //}
      this.IsLoadingPropertyCard = true;
      this.searchCriteria = searchParameters;
      this._propertyListingService.criteria = searchParameters;
      if (searchParameters.PropertyFor === 0 || searchParameters.PropertyFor === null || searchParameters.PropertyFor === undefined) {
        searchParameters.PropertyFor = 601;
      }
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        searchParameters.IsFavorite = params['isFav'] != undefined ? true : searchParameters.IsFavorite ? true : false;
        searchParameters.IsDisliked = params['isDisliked'] != undefined ? true : searchParameters.IsDisliked ? true : false;
      });
      if (this.searchCriteria.FilterTagCount != null && this.searchCriteria.FilterTagCount > 0) {
        if (this.currentFilter == FilterSearch.Dislike) {
          this.searchCriteria.IsDisliked = false;
        }
        else if (this.currentFilter == FilterSearch.Favorites) {
          this.searchCriteria.IsFavorite = false;
        }
      }
      if (searchParameters.IsDisliked) {
        searchParameters.PropertyFor = 602;
      }
      this.LoadAsyncList(searchParameters);
      this.getPropertyTabCount(searchParameters);
      if (this.searchCriteria.IsDisliked) {
        this.liveListingHeadingText = 'Dislike';
      }
      else if (this.searchCriteria.IsFavorite) {
        this.liveListingHeadingText = 'Favorites'
      }
      else if (this.searchCriteria.IsSavedSearch || this.IsFromSaveSearch) {
        this.liveListingHeadingText = 'Saved Search'
      }
      else if (this.searchCriteria.IsReset) {
        this.liveListingHeadingText = 'Live Listing'
        this.currentFilter = 0;
      }
      else {
        if (this.searchCriteria.FilterTagCount != null && this.searchCriteria.FilterTagCount > 0) {
          this.liveListingHeadingText = 'Search Results'
        }
        else {
          this.liveListingHeadingText = 'Live Listing'
        }
        this.currentFilter = 0;
      }
    }
  }

  async LoadAsyncList(searchParameters: IPropertySearchCriteria) {
    await this._propertyListingService.getPropertyListing(searchParameters).subscribe((response: IPropertyCard[]) => {
      this.properties = [];
      if (response != null && response.length > 0) {
        response.forEach((property: IPropertyCard) => {
          if (!this.properties.find(x => x.Id === property.Id)) {
            this.properties.push(property);
          }
        });

        this.IsLoadingPropertyCard = false;
        this.scrollToPropertyCard();
      }
      else {
        this.IsLoadingPropertyCard = false;
        this.scrollToPropertyCard();

      }

      if (this.searchCriteria.PropertyFor == 601) {
        this.propertyTabCount = (response != null && response.length > 0) ? response[0].TotalCount : 0;
      }
      else {
        this.propertyCount = (response != null && response.length > 0) ? response[0].TotalCount : 0;
      }
      this.loaderService.display(false);
      this.isSearchClicked = true;
    });
  }
  propertyTabCount: number;
  async getPropertyTabCount(searchParameters: IPropertySearchCriteria) {
    let IsCallCount = true;
    let user = this.authService.user;
    if (user != null && user != undefined) {
      if (this.searchCriteria.PropertyFor == 601) {
        if (this.showIs1031Tab && !this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker()) {
          IsCallCount = false;
        }
        if (this.authService.ExternalBroker() || this.authService.DataEntryStaff()) {
          IsCallCount = false;
        }
      }
      if (IsCallCount) {
        await this._propertyListingService.getPropertyListingCount(searchParameters).subscribe(response => {
          var number = response;
          if (searchParameters.PropertyFor == 601) {
            this.propertyCount = Number(number);
          }
          else {
            this.propertyTabCount = Number(number);
          }
        });
      }
      else {
        this.propertyTabCount = 0;
      }
    }
    else {
      this.propertyTabCount = 0;
    }

  }

  holdPropertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    if (searchParameters.IsMapView == false) {
      this.loaderService.display(true);
      this.searchCriteria = searchParameters;
      this._propertyListingService.criteria = searchParameters;
      this.propertyCount = (this.properties != null && this.properties.length > 0) ? this.properties[0].TotalCount : 0;
      this.loaderService.display(false);
    }
  }

  protected searchWithCriteria(searchParameters: IPropertySearchCriteria) {
    this.loaderService.display(true);
    this._propertyListingService.getPropertyListing(searchParameters).subscribe((response: IPropertyCard[]) => {
      this.enableScrollFn = true;
      if (response != null && response.length > 0) {
        response.forEach((property: IPropertyCard) => {
          if (!this.properties.find(x => x.Id === property.Id)) {
            this.properties.push(property);
          }
        });
      }
      this.loaderService.display(false);
    });
  }

  defaultSearchCriteriaValues() {

    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 20;
    this.searchCriteria.Address = '';
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Tenants = [];
    this.searchCriteria.Ratings = [];
    this.searchCriteria.TenantAddress = [];
    this.searchCriteria.SubCategories = [];
    this.searchCriteria.PropertyStatus = [];
    this.searchCriteria.Brokerages = [];
    this.searchCriteria.Terms = [];
    this.searchCriteria.SortValue = 'PHL';
    this.searchCriteria.IsMapView = false;
    this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
    this.searchCriteria.PropertyFor = PropertyFor.Sale;
    this.searchCriteria.IsTileList = true;
    this.searchCriteria.IsSearchButtonClicked = false;
    this.searchCriteria.IsPortfolio = false;
  }
}
